<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
         <Table :columns="columnsExpand" :data="row.items" stripe ref="table" ></Table>
    </div>
</template>
<script>
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    export default {
        props: {
            row: Object
        },
         data() {
            var columns =  [
                     {
                        title: Util.L('TransDate'),
                        key: 'transDate',
                         render: (h, params) => {
                            return h("span", Util.toViewDatePickerString(params.row.transDate));
                        }
                    }
                    ,
                    {
                        title: Util.L('ConditionType'),
                        key: 'conditionTypeName'
                    },
                   
                    {
                        title: Util.L('Qty'),
                        key: 'qty',
                        align: "right",
                         render: (h, params) => {
                            return h("span", Util.toViewNumberString(Math.abs(params.row.qty)));
                        }
                    }
                ]
            return {
                columnsExpand : columns,
            }
        },
    };
</script>
